var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('itinerary-seo-teaser-list',{attrs:{"itinerary-id":_vm.itineraryId,"seo-loading":_vm.seoLoading,"seo-error":_vm.seoError,"seo-teaser-items":_vm.seoItems,"selected-domain":_vm.selectedDomain},on:{"saveTeasers":_vm.saveTeasers,"updateDomain":_vm.updateItineraryDomain}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243648e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/itinerary/ItineraryEditSEO.vue
// module id = null
// module chunks = 